import {
  ActivityApi,
  type ActivityActorsResponse,
  type ActivityListResponse,
  type ListAccountActivitySortOrderEnum,
  type ListFamilyActivitySortOrderEnum
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';
import type {
  AccountActivitySearchParams,
  FamilyActivityActorSearchParams,
  FamilyActivitySearchParams
} from '@/types/activity';

export type { ActivityActorsResponse, ActivityListResponse };

class WrappedActivityApi {
  async listFamilyActivity(
    familyId: string,
    params: FamilyActivitySearchParams = {}
  ): Promise<ApiResult<ActivityListResponse>> {
    return withApiSetup(
      (config) => new ActivityApi(config),
      getApiConfiguration,
      (api) =>
        api.listFamilyActivity(
          familyId,
          params.page,
          params.pageSize,
          params.sortOrder as ListFamilyActivitySortOrderEnum | undefined,
          params.createdAfter,
          params.createdBefore,
          params.userId,
          params.targetType,
          params.action,
          params.category
        )
    );
  }

  async listFamilyActivityActors(
    familyId: string,
    params: FamilyActivityActorSearchParams = {}
  ): Promise<ApiResult<ActivityActorsResponse>> {
    return withApiSetup(
      (config) => new ActivityApi(config),
      getApiConfiguration,
      (api) =>
        api.listFamilyActivityActors(
          familyId,
          params.createdAfter,
          params.createdBefore,
          params.targetType,
          params.action,
          params.category
        )
    );
  }

  async listAccountActivity(params: AccountActivitySearchParams = {}): Promise<ApiResult<ActivityListResponse>> {
    return withApiSetup(
      (config) => new ActivityApi(config),
      getApiConfiguration,
      (api) =>
        api.listAccountActivity(
          params.page,
          params.pageSize,
          params.sortOrder as ListAccountActivitySortOrderEnum | undefined,
          params.createdAfter,
          params.createdBefore
        )
    );
  }
}

export const activityApi = new WrappedActivityApi();
